// extracted by mini-css-extract-plugin
export default {"page-size-dropdown":"PVHiPR8UVioq_MrYxHRB"};